import React, { useState, useEffect } from 'react';
import { API_URL } from '../config';
import './ProjectsList.css';

interface Project {
  id: number;
  name: string;
  object?: string;
  client_id: number;
  commune_id: number;
  created_at: string;
}

interface ProjectsListProps {
  onSelectProject: (projectId: number, projectName: string) => void;
}

const ProjectsList: React.FC<ProjectsListProps> = ({ onSelectProject }) => {
  const [projects, setProjects] = useState<Project[]>([]);
  const [search, setSearch] = useState('');

  useEffect(() => {
    loadProjects();
  }, []);

  const loadProjects = async () => {
    try {
      const response = await fetch(`${API_URL}/projects`);
      const data = await response.json();
      setProjects(data);
    } catch (error) {
      console.error('Error loading projects:', error);
    }
  };

  const deleteProject = async (e: React.MouseEvent, projectId: number) => {
    e.stopPropagation();
    if (!window.confirm('Supprimer ce projet et toutes ses données ?')) return;
    
    try {
      const response = await fetch(`${API_URL}/projects/${projectId}`, { method: 'DELETE' });
      if (response.ok) loadProjects();
    } catch (error) {
      console.error('Error deleting project:', error);
    }
  };

  const filteredProjects = projects.filter(p =>
    p.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="projects-list">
      <div className="search-bar">
        <input
          type="text"
          placeholder="🔍 Rechercher un projet..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="projects-grid">
        {filteredProjects.map(project => (
          <div
            key={project.id}
            className="project-card"
            onClick={() => onSelectProject(project.id, project.name)}
          >
            <button className="delete-btn" onClick={(e) => deleteProject(e, project.id)}>✕</button>
            <h3>{project.name}</h3>
            {project.object && <p className="project-desc">{project.object}</p>}
            <div className="project-meta">
              <span className="date">{new Date(project.created_at).toLocaleDateString('fr-FR')}</span>
            </div>
          </div>
        ))}
      </div>

      {filteredProjects.length === 0 && (
        <div className="empty-state">
          <p>Aucun projet trouvé</p>
        </div>
      )}
    </div>
  );
};

export default ProjectsList;
